import React from "react";
import { FaCheckCircle, FaHourglassHalf, FaSearch, FaSyncAlt, FaVoteYea } from "react-icons/fa";

const FILTERS = [
  {
    value: "all",
    label: "Tous",
    icon: FaVoteYea,
  },
  {
    value: "pending",
    label: "À répondre",
    icon: FaHourglassHalf,
  },
  {
    value: "answered",
    label: "Répondus",
    icon: FaCheckCircle,
  },
];

export default function VotesToolbar({
  searchTerm,
  onSearchChange,
  viewFilter,
  onViewFilterChange,
  loading = false,
  onRefresh,
  stats,
}) {
  return (
    <div className="space-y-3">
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
        <div>
          <p className="text-sm font-bold text-slate-950 dark:text-white">
            Liste des votes disponibles
          </p>

          <p className="mt-0.5 text-xs leading-5 text-slate-500 dark:text-slate-400">
            Recherche par titre, description ou type de vote.
          </p>
        </div>

        <button
          type="button"
          onClick={onRefresh}
          disabled={loading}
          className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-900"
        >
          <FaSyncAlt className={loading ? "animate-spin" : ""} />
          Rafraîchir
        </button>
      </div>

      <div className="grid gap-3 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-center">
        <div className="relative">
          <input
            type="text"
            placeholder="Rechercher un vote ou un sondage…"
            value={searchTerm}
            onChange={(event) => onSearchChange?.(event.target.value)}
            className="min-h-12 w-full rounded-2xl border border-slate-200 bg-white py-3 pl-11 pr-4 text-sm font-semibold text-slate-900 shadow-sm outline-none transition placeholder:text-slate-400 focus:border-violet-400 focus:ring-2 focus:ring-violet-200 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-100 dark:focus:ring-violet-900/50"
          />

          <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
        </div>

        <div className="grid grid-cols-3 gap-2">
          {FILTERS.map((filter) => {
            const Icon = filter.icon;
            const active = viewFilter === filter.value;

            const count =
              filter.value === "answered"
                ? stats?.answered
                : filter.value === "pending"
                ? stats?.pending
                : stats?.total;

            return (
              <button
                key={filter.value}
                type="button"
                onClick={() => onViewFilterChange?.(filter.value)}
                className={[
                  "inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl border px-3 text-xs font-bold transition sm:text-sm",
                  active
                    ? "border-violet-400 bg-violet-600 text-white shadow-md shadow-violet-200 dark:border-violet-400 dark:bg-violet-500 dark:shadow-black/20"
                    : "border-slate-200 bg-white text-slate-700 hover:border-violet-200 hover:bg-violet-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:border-violet-700 dark:hover:bg-violet-950/30",
                ].join(" ")}
              >
                <Icon className="hidden sm:block" />
                <span>{filter.label}</span>
                <span
                  className={[
                    "rounded-full px-1.5 py-0.5 text-[10px]",
                    active
                      ? "bg-white/20 text-white"
                      : "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-300",
                  ].join(" ")}
                >
                  {count || 0}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}